<div class="dialog">
  <lucide-icon name="x" class="dialog-close" (click)="cancel()" [size]="20"></lucide-icon>

  <div class="dialog-header">
    <lucide-icon name="users" class="users-icon" [size]="20"></lucide-icon>
    <div class="dialog-title">{{ dialogTitle }}</div>
  </div>

  <form [formGroup]="form" class="dialog-body">
    <div class="form-field">
      <label>Access group name <span class="required">*</span></label>
      <input
        class="text-input"
        [class.input-error]="form.get('name')?.touched && form.get('name')?.errors"
        type="text"
        placeholder="Enter a name"
        formControlName="name"
      />
      @if (form.get('name')?.touched && form.get('name')?.hasError('uniqueName')) {
        <span class="error-message">Access group name already exists</span>
      }
    </div>

    <div class="form-field">
      <div class="scope-label-row">
        <label
          >Scope
          @if (!form.get('allIntegrations')?.value) {
            <span class="required">*</span>
          }
        </label>
        <div class="everything-toggle">
          <span class="everything-label">Everything</span>
          <mat-slide-toggle
            formControlName="allIntegrations"
            color="primary"
            (change)="onAllIntegrationsToggle($event.checked)"
          ></mat-slide-toggle>
        </div>
      </div>
      <div class="scope-row" [class.scope-row-disabled]="form.get('allIntegrations')?.value">
        <mat-form-field appearance="outline" class="scope-category-select">
          <mat-select
            placeholder="Select category"
            formControlName="scopeCategory"
            panelClass="access-group-select-panel"
            [disabled]="form.get('allIntegrations')?.value"
          >
            <mat-option value="integration">
              <div class="scope-option">
                <lucide-icon name="plug" [size]="16"></lucide-icon>
                <span>Integration</span>
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <app-multi-select
          class="scope-items-select"
          [options$]="integrationOptions$"
          [selectedIds]="selectedIntegrationIds"
          [withSearch]="true"
          [placeHolder]="'Select items'"
          [valid]="integrationValid$"
          [disabled]="!form.get('scopeCategory')?.value || form.get('allIntegrations')?.value"
          (optionOnSelection)="onIntegrationSelected($event)"
        >
        </app-multi-select>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <label>Role <span class="required">*</span></label>
        <mat-form-field appearance="outline" class="w-100">
          <mat-select placeholder="Select role" formControlName="role" panelClass="access-group-select-panel">
            <mat-select-trigger>{{ roleTitle(form.get('role')?.value ?? null) }}</mat-select-trigger>
            @for (role of roles; track role.id) {
              <mat-option [value]="role.id">
                <div class="role-option">
                  <span class="radio-circle" [class.selected]="form.get('role')?.value === role.id"></span>
                  <div class="role-text">
                    <div class="role-title">{{ role.name }}</div>
                    <div class="role-desc">{{ role.description }}</div>
                  </div>
                </div>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="form-field users-input">
      <label>Assign users</label>
      <app-multi-select
        class="users-select"
        [options$]="userOptions$"
        [selectedIds]="selectedUserEmails"
        [withSearch]="true"
        [placeHolder]="'Select one or more users'"
        (optionOnSelection)="onUserSelected($event)"
      >
      </app-multi-select>
    </div>
  </form>

  <div class="dialog-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="submit()">
      {{ submitButtonText }}
    </button>
  </div>
</div>
